/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}\n/*# sourceMappingURL=admin.component.css.map*/"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/admin/admin/admin.component.css.shim.ngstyle.js.pre-build-optimizer.js